import { BryntumCalendarProps } from '@bryntum/calendar-react-thin';

export type CalendarViewMode = NonNullable<BryntumCalendarProps['mode']>;

export type ShiftLabel = {
  id: string;
  name: string;
  tagName: string;
};

export type ShiftBreak = {
  id: string;
  startDate: Date;
  endDate: Date;
};

export const START_DATE_PARAM = 'startDate';
export const VIEW_PARAM = 'view';

export type PageQueryParams = {
  date: Date;
  mode: CalendarViewMode;
};
